import { PiiCategory, meta } from "./meta.mjs";
import z from "zod";

// src/models/customerIoChannelOptOut.ts
/** Firestore field on `customer_notification_configuration` for Customer.io channel opt-out state. */
const CUSTOMER_IO_CHANNEL_OPT_OUT_FIELD = "customerIoChannelOptOut";
const customerIoOptOutRecordSchema = z.object({
	/** ISO-8601 timestamp (from webhook epoch or server time). */
	optedOutAt: z.string(),
	cioEventId: z.string(),
	source: z.string(),
	metadata: meta(z.record(z.string(), z.unknown()).optional(), { pii: { category: "freeText" } })
});
const customerIoChannelOptOutStateSchema = z.object({
	email: customerIoOptOutRecordSchema.nullable(),
	sms: customerIoOptOutRecordSchema.nullable()
});
/** Entire field absent or null on existing docs until first CIO subscription event. */
const customerIoChannelOptOutFieldSchema = customerIoChannelOptOutStateSchema.nullable().optional();
function emptyCustomerIoChannelOptOutState() {
	return {
		email: null,
		sms: null
	};
}
function parseCustomerIoChannelOptOutState(raw) {
	if (raw === null || raw === void 0) return null;
	const parsed = customerIoChannelOptOutStateSchema.safeParse(raw);
	return parsed.success ? parsed.data : null;
}
/** True when a channel has an active CIO opt-out record. */
function isCustomerIoChannelOptedOut(state, channel) {
	return state?.[channel] != null;
}

export { CUSTOMER_IO_CHANNEL_OPT_OUT_FIELD, customerIoChannelOptOutFieldSchema, customerIoChannelOptOutStateSchema, customerIoOptOutRecordSchema, emptyCustomerIoChannelOptOutState, isCustomerIoChannelOptedOut, parseCustomerIoChannelOptOutState };
//# sourceMappingURL=customerIoChannelOptOut.mjs.map